import Axios from "axios";
import KnockOut, { options } from "knockout";
import KnockOutMapping from "knockout-mapping";
import { loadScript } from "@paypal/paypal-js";

import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class CheckoutSummaryViewModel {
    constructor() {
        let self: any = this;

        self.localizer = Localizer;

        self.isDataFetched = KnockOut.observable(false);
        self.isExpressCart = KnockOut.observable(true);
        self.isExpressProduct = KnockOut.observable(false);
        self.isTermsApproved = KnockOut.observable(false);
        self.isTNTPointPickup = KnockOut.observable(false);
        self.deliveryDate = KnockOut.observable();
        self.labelDeliveryDate = KnockOut.observable();
        self.businessDiscountNotes1 = KnockOut.observable();
        self.businessDiscountNotes2 = KnockOut.observable();
        self.tntPoint = KnockOut.observable("");
        self.orderNotes = KnockOut.observable("");

        self.payPalOrderId = KnockOut.observable();
        self.payPalOrderSuccess = KnockOut.observable(false);

        self.update = function (cartInfo) {
            KnockOutMapping.fromJS(cartInfo, {}, self);
            (<any>window).App.viewModels.cartPreview.update(cartInfo);

            self.isExpressCart(cartInfo.cartRows.every(function (cartRow) { return cartRow.is24HoursDelivery }));
            self.isExpressProduct(cartInfo.cartRows.some(function (cartRow) { return cartRow.is24HoursDelivery }));
        };

        self.setDeliveryDate = function () {
            self.isTNTPointPickup(false);
        };

        self.setCouponCode = async function () {
            let $context = $("#Page");

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);

            try {
                let cartDetail = (await Axios.post((<any>window).App.routes.Cart_SetCouponCode, { couponCode: self.couponCode() }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
                self.update(cartDetail.cartInfo);
            } catch (error) {
                if (error.response.status === 400) {
                    $(".validation").show();
                    FormHelper.setValidation($context, error.response.data);
                }
            }

            FormHelper.enableControls($context);
        }

        self.createOrder = async function (paymentSource: string) {
            var $context = $("#Page");

            self.payPalOrderSuccess = false;

            FormHelper.resetValidation($context);
            FormHelper.disableControls($context);

            try {
                $(".validation").hide();

                let orderPlace = (await Axios.post((<any>window).App.routes.Checkout_Summary, {
                    deliveryDate: self.deliveryDate(),
                    tntPoint: self.tntPoint(),
                    isTermsApproved: self.isTermsApproved(),
                    isTNTPointPickup: self.isTNTPointPickup(),
                    orderNotes: self.orderNotes(),
                    paymentSource: paymentSource
                }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

                self.payPalOrderId = orderPlace.payPalOrderId;
                self.payPalOrderSuccess = true;

                if ((<any>window).fbq) {
                    var contentCategory = "checkout",
                        contentIDs = [],
                        contents = [],
                        currency = "EUR",
                        value = self.cartTotalWithCosts().split(',').join('.');

                    for (var i = 0; i < self.cartRows().length; i++) {
                        contentIDs.push(self.cartRows()[i].productCode());
                        contents.push({ id: self.cartRows()[i].productCode(), quantity: self.cartRows()[i].quantity(), item_price: self.cartRows()[i].unitPrice().split(',').join('.') });
                    }

                    (<any>window).fbq("track", "InitiateCheckout", { content_category: contentCategory, content_ids: contentIDs, contents: contents, currency: currency, value: value });
                }

                if ((<any>window).sendinblue) {
                    var track_event = { "data": { "items": [] } };

                    for (var i = 0; i < self.cartRows().length; i++) {
                        var cartRow = {
                            "ProductName": self.cartRows()[i].productName(),
                            "ProductImageUrl": "/it/media/product/images/150-150-fix/" + self.cartRows()[i].productImageCode(),
                            "Quantity": self.cartRows()[i].quantity(),
                            "VariantCode": self.cartRows()[i].variantCode(),
                            "VariantName": self.cartRows()[i].variantDescription(),
                            "UnitPrice": self.cartRows()[i].unitPrice(),
                            "TotalPrice": self.cartRows()[i].rowPrice()
                        };
                        track_event.data.items.push(cartRow);
                    }

                    (<any>window).sendinblue.track("Click_Acquista", {}, track_event);
                }

                if (self.cartTotalWithCosts() == "0,00") {
                    window.location.href = (<any>window).App.routes.Checkout_Confirm;
                }
            } catch (error) {
                self.payPalOrderSuccess = false;

                $(".validation").show();
                if (error.response.status === 400) {
                    FormHelper.setValidation($context, error.response.data);
                }
            }

            return self.payPalOrderId;
        }

        self.captureOrder = async function () {
            await Axios.post((<any>window).App.routes.Checkout_Capture, { id: self.payPalOrderId }, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
            window.location.href = (<any>window).App.routes.Checkout_Confirm;
        }

        async function init() {
            var $context = $("#Page");

            let cartInfo = (await Axios.post((<any>window).App.routes.Cart_GetCartInfo)).data;
            KnockOutMapping.fromJS(cartInfo, {}, self);
            self.isDataFetched(true);

            self.isExpressCart(cartInfo.cartRows.every(function (cartRow) { return cartRow.is24HoursDelivery }));
            self.isExpressProduct(cartInfo.cartRows.some(function (cartRow) { return cartRow.is24HoursDelivery }));

            self.labelDeliveryDate(cartInfo.firstDeliveryDateString);
            self.businessDiscountNotes1(cartInfo.businessDiscountNotes1);
            self.businessDiscountNotes2(cartInfo.businessDiscountNotes2);

            var itemList = [];
            for (var i in cartInfo.cartRows) {
                itemList.push({
                    item_id: cartInfo.cartRows[i].productCode,
                    item_name: cartInfo.cartRows[i].productName,
                    affiliation: "IloveOstrica",
                    item_category: cartInfo.cartRows[i].categoryName,
                    coupon: cartInfo.couponCode,
                    currency: "EUR",
                    price: parseFloat(cartInfo.cartRows[i].unitPrice.replace(/\./g, "").replace(",", ".")),
                    quantity: cartInfo.cartRows[i].quantity
                });
            }

            GTagHelper.sendEvent("begin_checkout", {
                currency: "EUR",
                value: parseFloat(cartInfo.cartTotalWithCosts.replace(/\./g, "").replace(",", ".")),
                coupon: cartInfo.couponCode,
                items: itemList
            });

            (<any>window).window.dataLayer = (<any>window).window.dataLayer || [];
            (<any>window).window.dataLayer.push({ ecommerce: null });
            (<any>window).window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: "EUR",
                    value: parseFloat(cartInfo.cartTotalWithCosts.replace(/\./g, "").replace(",", ".")),
                    items: itemList
                }
            });

            (<any>$("[data-fancybox]")).fancybox({
                fullScreen: false,
                thumbs: false,
                slideShow: false,
                iframe: {
                    scrolling: "auto"
                },
                image: {
                    protect: true
                }
            });

            // Reference: https://developer.paypal.com/docs/checkout/advanced/integrate/

            let paypal = await loadScript({
                clientId: (<any>window).App.bag.payPalClientId,
                currency: "EUR",
                components: ["card-fields", "buttons", "messages"]
            });

            let isCartDisabled = (<any>window).App.bag.isCartDisabled === "True";
            let isShipping = (<any>window).App.bag.isShipping === "True";

            if (paypal && isShipping && !isCartDisabled) {
                const cardFields = paypal.CardFields({
                    createOrder: async function (): Promise<string> {
                        return self.createOrder("card");
                    },
                    onApprove: async function (data: any) {
                        if (!data.liabilityShift || (data.liabilityShift !== "POSSIBLE" && data.liabilityShift !== "YES")) {
                            window.location.href = (<any>window).App.routes.Checkout_ErrorPayment;
                        } else {
                            self.captureOrder();
                        }
                    },
                    onError: async function (error: any) {
                        if (self.payPalOrderSuccess || error.message !== "Expected an order id to be passed") {
                            window.location.href = (<any>window).App.routes.Checkout_ErrorPayment;
                        }
                    },
                    style: {
                        'input': {
                            'appearance': 'true',
                            'font-size': '16px',
                            'font-family': 'Arial',
                            'padding': '10px 10px'
                        }
                    }
                });

                // Render each field after checking for eligibility
                if (cardFields.isEligible()) {
                    const nameField = cardFields.NameField({ placeholder: self.localizer.get("Checkout.Common.CardField_Name_PlaceHolder") });
                    nameField.render("#card-name-field-container");

                    const numberField = cardFields.NumberField({ placeholder: self.localizer.get("Checkout.Common.CardField_Number_PlaceHolder") });
                    numberField.render("#card-number-field-container");

                    const cvvField = cardFields.CVVField({});
                    cvvField.render("#card-cvv-field-container");

                    const expiryField = cardFields.ExpiryField({ placeholder: self.localizer.get("Checkout.Common.CardField_Expiry_PlaceHolder") });
                    expiryField.render("#card-expiry-field-container");

                    // Add click listener to submit button and call the submit function on the CardField component
                    document.getElementById("card-field-submit-button").addEventListener("click", () => {
                        FormHelper.resetValidation($context);
                        $(".validation").hide();

                        cardFields.submit().then(() => { }).catch((error: any) => {
                            switch (error.message) {
                                default:
                                    console.log(error);
                                    break;
                                case "INVALID_NUMBER":
                                    $(".validation").show();
                                    FormHelper.setValidation($context, { "CardNumber": [self.localizer.get("Checkout.Common.CardField_Number_NotValid")] });
                                    break;
                                case "INVALID_CVV":
                                    $(".validation").show();
                                    FormHelper.setValidation($context, { "CVV": [self.localizer.get("Checkout.Common.CardField_CVV_NotValid")] });
                                    break;
                                case "INVALID_EXPIRY":
                                    $(".validation").show();
                                    FormHelper.setValidation($context, { "DateExpiration": [self.localizer.get("Checkout.Common.CardField_Expiry_NotValid")] });
                                    break;
                            }
                        });
                    });
                    document.getElementById("paypal-card-fields").classList.remove("hden");
                }

                await paypal.Buttons({
                    style: {
                        layout: 'horizontal',
                        tagline: false,
                        label: 'pay'
                    },
                    createOrder: async function (): Promise<string> {
                        return self.createOrder("paypal");
                    },
                    onApprove: async function () {
                        self.captureOrder();
                    },
                    onError: async function (error: any) {
                        if (self.payPalOrderSuccess || error.message !== "Expected an order id to be passed") {
                            window.location.href = (<any>window).App.routes.Checkout_ErrorPayment;
                        }
                    }
                }).render("#paypal-buttons");
            }
        }

        init();
    }
}